import { render, staticRenderFns } from "./BaseHomeworkArchiver.vue?vue&type=template&id=42c7d902&"
import script from "./BaseHomeworkArchiver.vue?vue&type=script&lang=js&"
export * from "./BaseHomeworkArchiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports